/**
 * Returns a list of roots following the binyan huf'al.
 *
 * @returns {string[]} Hebrew roots following the binyan huf'al.
 */
export default [
	"אכל",
	"דבר",
	"עבר",
	"עמד",
	"קרא",
	"שמע",
	"זכר",
	"חזק",
	"חטא",
	"כתב",
	"מלך",
	"מצא",
	"נגד",
	"נפל",
	"עבר",
	"פקד",
	"רום",
	"שכב",
	"אבד",
	"אמן",
	"גדל",
	"חשב",
	"יטב",
	"כבד",
	"לבש",
	"קדש",
	"קרב",
	"שנא",
	"שאל",
	"שאר",
	"שבע",
	"שחת",
	"שכן",
	"שכח",
	"שלך",
	"שלם",
	"בער",
	"בקע",
	"ברא",
	"ברח",
	"דבק",
	"דרך",
	"זעק",
	"חלק",
	"חרם",
	"חרש",
	"כעס",
	"כשל",
	"מאס",
	"משל",
	"נבט",
	"נחל",
	"נצח",
	"סגר",
	"סתר",
	"ערך",
	"פרה",
	"פלא",
	"פלל",
	"פעל",
	"פרד",
	"פרש",
	"צלח",
	"צרר",
	"קלל",
	"קנה",
	"רחק",
	"רכב",
	"רעע",
	"שבע",
	"שכל",
	"שכם",
	"אשם",
	"בדל",
	"בהל",
	"בחן",
	"בשל",
	"גבה",
	"גנב",
	"זרק",
	"חלם",
	"חלף",
	"חרב",
	"חרד",
	"חרף",
	"חשך",
	"חתם",
	"טמן",
	"טרף",
	"כלם",
	"כנע",
	"כרע",
	"משך",
	"נהג",
	"סמך",
	"פחד",
	"פרד",
	"פרח",
	"פשט",
	"צדק",
	"צמח",
	"צפן",
	"קדם",
	"קצף",
	"קשב",
	"רבץ",
	"רגז",
	"רגל",
	"רחב",
	"רעש",
	"רשע",
	"שפל",
	"שקט",
	"ברר",
	"גבר",
	"געל",
	"טעם",
	"כזב",
	"כחש",
	"כנס",
	"לחץ",
	"מטר",
	"מעט",
	"מרד",
	"משל",
	"נגש",
	"נזל",
	"עלם",
	"עצב",
	"עשר",
	"פגש",
	"פרע",
	"צבא",
	"צמת",
	"קסם",
	"רבע",
	"רגע",
	"רעב",
	"רעם",
	"רקע",
	"שאב",
	"שבח",
	"שחר",
	"שכל",
	"שכר",
	"שען",
	"שקף",
	"שתל",
	"שלכ‎",
	"מלכ‎",
	"דרכ‎",
	"ערכ‎",
	"חשכ‎",
	"משכ‎",
	"סמכ‎",
	"אמנ",
	"שכנ",
	"בחנ",
	"טמנ",
	"צפנ",
	"שענ",
	"רומ",
	"שלמ",
	"חרמ",
	"שכמ",
	"אשמ",
	"חלמ",
	"חתמ",
	"כלמ",
	"קדמ",
	"עלמ",
	"טעמ",
	"חלפ",
	"חרפ",
	"טרפ",
	"קצפ",
	"שקפ",
	"רבצ",
	"לחצ",
];
